<template>
    <div class="strategy">
        <div v-html="integral_strategy">{{integral_strategy}}</div>
    </div>
</template>
<script>
        export default {
            name:"Strategy",
            data(){
                return {
                    integral_strategy:'' 
                }
            },
            mounted(){
                this.axios.post('/wechat.php/Integral/getIntegralDetailData',{
                    user_id: localStorage.user_id
                }).then(
                    res=>{
                        this.integral_strategy=res.data.data.integral_strategy;
                    }
                )
            }
        }
        </script>
<style scoped>
    .strategy{
        padding: 30px;
        background: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/pages/integral/Strategy.vue